import type { YearCalculationResponse } from "../types/api";

export function getYearDataCacheKey(lat: number, lon: number, year: number): string {
	return `solberegning_year_${lat.toFixed(4)}_${lon.toFixed(4)}_${year}`;
}

export function getYearDataCache(lat: number, lon: number, year: number): YearCalculationResponse | null {
	try {
		const key = getYearDataCacheKey(lat, lon, year);
		const cached = localStorage.getItem(key);
		if (!cached) return null;
		return JSON.parse(cached) as YearCalculationResponse;
	} catch {
		return null;
	}
}

export function setYearDataCache(lat: number, lon: number, year: number, data: YearCalculationResponse): void {
	try {
		const key = getYearDataCacheKey(lat, lon, year);
		localStorage.setItem(key, JSON.stringify(data));
	} catch {
		// localStorage might be full or unavailable, ignore
	}
}

export function cacheNeedsRefresh(data: YearCalculationResponse): boolean {
	return data.results.some((day) => day.status === "Multiple sunrises" && (!day.events || day.events.length < 3));
}

/** Forgets every cached year (on sign-out, so the next person can't read them). */
export function clearYearDataCache(): void {
	try {
		for (const key of Object.keys(localStorage)) {
			if (key.startsWith("solberegning_year_")) localStorage.removeItem(key);
		}
	} catch {
		// localStorage unavailable, nothing to clear
	}
}
